var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { pickBy } from "lodash";
const _RicosTextStyle = class _RicosTextStyle {
  constructor(textStyle) {
    __publicField(this, "textStyle");
    __publicField(this, "getTextStyle", () => this.textStyle);
    __publicField(this, "toCustomStyle", () => {
      return { lineHeight: this.textStyle.lineHeight };
    });
    __publicField(this, "overrideWith", (textStyle) => {
      return _RicosTextStyle.of({ ...this.textStyle, ...textStyle });
    });
    this.textStyle = this.preprocess(textStyle);
  }
  preprocess(textStyle) {
    let lineHeight = textStyle.lineHeight;
    if (lineHeight && !Number(lineHeight)) {
      if (lineHeight.includes("px") || lineHeight.includes("em")) {
        lineHeight = lineHeight.slice(0, lineHeight.length - 2);
      }
    }
    return pickBy({ ...textStyle, lineHeight });
  }
  static of(textStyle) {
    return new _RicosTextStyle(textStyle || {});
  }
};
__publicField(_RicosTextStyle, "fromCustomStyle", (customStyle) => {
  const { lineHeight } = customStyle;
  const textStyle = { lineHeight };
  return _RicosTextStyle.of(textStyle);
});
let RicosTextStyle = _RicosTextStyle;
export {
  RicosTextStyle
};
//# sourceMappingURL=text-style.js.map
